<template>
  <!-- <el-row>
    <el-col :xs="12" :sm="12" :lg="18">
      <div>
        <p><span class="pain-txt">头像：</span><span class="grey-txt">上传头像</span></p>
        <p style="margin-left: 40px;"><span class="pain-txt">上传图片只支持jpeg/png/gif格式，若不设置则使用默认头像</span></p>

        <el-upload
                class="upload-demo"
                :http-request="httpRequestFile"
                :before-upload="onBeforeUpload"
                :show-file-list="false"
                accept=".JPG, .PNG, .JPEG,.jpg, .png, .jpeg"
                action="">
          <el-button style="width: 128px;margin-top: 40px">上传头像</el-button>
        </el-upload>


      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="6"> -->
      <div style="width: 350px;">
        <!-- <p class="avat-txt"><span>点击头像预览大图</span></p> -->
        <div class="ava-box">
          <!-- <div class="demo-image__preview"> -->
            <el-image
              style="width: 96px; height: 96px;border-radius: 50%;overflow: hidden;"
              :src="userInfoForm.headImg"
              :preview-src-list="srcList"
              :lazy='true'
              @error="loadFailed"
              >
            </el-image>
          <!-- </div> -->
        </div>

        <!-- <div> -->
          <p class="pain-txt" style="padding: 5px 0;">上传图片只支持jpeg/png/gif格式，若不设置则使用默认头像</p>

          <el-upload
                  class="upload-demo"
                  :http-request="httpRequestFile"
                  :before-upload="onBeforeUpload"
                  :show-file-list="false"
                  accept=".JPG, .PNG, .JPEG,.jpg, .png, .jpeg"
                  action="">
            <el-button style="width: 128px;" size="mini">上传头像</el-button>
          </el-upload>

        <!-- </div> -->

      </div>
    <!-- </el-col>
  </el-row> -->
</template>
<script>
  import { getToken } from '@/utils/auth'
  import { personUpdateHeadImg } from '@/api/user'
  import { mapGetters } from 'vuex';
  import { getUserSave } from '@/api/user'

  export default {
    props: ['optionDatadd'],
    watch: {
      optionDatadd: {
        handler(val) {
          // this.arrayRule = val
        },
        deep: true,
        immediate: true
      },
    },
    data() {
      return {
        defaultSrc: `${process.env.VUE_APP_BASE_CDN}/static/images/avat.png`,
        srcList: [],
        userInfoForm: {
          "account": "",
          "agentCode": "",
          "bossId": "",
          "brandIdentify": "",
          "contactInfo": "",
          "createBy": "",
          "createTime": "",
          "email": "",
          "headImg": "",
          "isDeleted": false,
          "menuList": [],
          "nickname": "",
          "password": "",
          "state": "0",
          "tsAccount": "",
          "userId": "",
          "userSite": "",
          "userType": "",
          "worktimeType": ""
        },
      }
    },
    computed: {
      ...mapGetters([
        'userInfo',
      ])
    },
    mounted() {
      this.userInfoForm = this.userInfo;
      this.srcList = [this.userInfo.headImg];
    },
    methods: {
      httpRequestFile (file) {
        const isJPG = file.file.type === 'image/jpeg' || 'image/png' || 'image/gif';
        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG/GIF/PNG 格式!');
          return false;
        }
        const formData = new FormData();
        formData.append('file', file.file);
        personUpdateHeadImg(formData).then(res => {
          if(res.errcode != 0) return;
          this.$message.success(res.errmsg);
          this.userInfoForm.headImg = res.data;
          this.srcList = [res.data];
          // 更新头像
          // store.commit('SET_AVATAR', res.data)
          // getInfo(getToken('access_token')).then(response => {})
        });
      },
      onBeforeUpload(file){
        let fileSize = file.size / 1024;
        if(fileSize > 800){
          this.$message.error('上传文件大小不能超过 800k!');
          return false;
        }
        return true;
      },
      onSubmit() {

        getUserSave('update',{
          ...this.userInfoForm
        }).then(res => {
          let code = res.errcode
          if (code == 0) {
            this.$message.success(res.errmsg)
          }
        })
      },
      loadFailed(){
        this.srcList = [this.defaultSrc];
        this.userInfo.headImg = this.defaultSrc;
      }
    }
  }
</script>
<style scoped>
.ava-box{
  width: 280px;
  border: 1px solid #D8D8D8;
  text-align: center;
  padding: 37px 0;
  border-radius: 3px;
}

.pain-txt {
  font-weight: 400!important;
  color: #838A9D!important;
}
.avat-txt{
  width: 280px;
  line-height: 40px;
  font-size: 12px;
  color: #3C4353;
  text-align: center;
}

.ava-box img {
  width: 96px;
  height: 96px;
  border-radius: 50%;
  overflow: hidden;
}
</style>